import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'Lpu'

const GetAll = (companyId, limit, index, descricao = '', data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${companyId}?descricao=${descricao}&limit=${limit}&index=${index}`, data, config)
const GetByPci = (pciId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/pci/${pciId}`, data, config)
const Get = (lpuId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${lpuId}`, data, config)
const Download = (lpuId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/template/${lpuId}`, data, config)
const Upload = (lpuId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/upload/${lpuId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (lpuId, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${lpuId}`, data, config)
const UpdateObservation = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/observacao`, data, config)

export default {
  GetAll,
  GetByPci,
  Get,
  Download,
  Upload,
  Create,
  Update,
  Delete,
  UpdateObservation
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/lpu.js